// Helpers
const id = (n, prefix = "id") => `${prefix}-${n.toString().padStart(4, "0")}`;
const day = (offsetDays, h = 9, m = 0) => {
    const d = new Date("2026-05-18T00:00:00+10:00");
    d.setDate(d.getDate() + offsetDays);
    d.setHours(h, m, 0, 0);
    return d.toISOString();
};
const addHours = (iso, hours) => {
    const d = new Date(iso);
    d.setMinutes(d.getMinutes() + Math.round(hours * 60));
    return d.toISOString();
};
// ---------- Accounts ----------
// crb7a_whmcsid: WHMCS client ID as it appears in WHMCS (string). Five of the
// seven seeded accounts are wired to WHMCS — Tailspin and Adventure Works are
// intentionally left blank so the disabled-state of "Post to WHMCS" is
// visible in the demo data.
export const accounts = [
    { accountid: id(1, "acc"), name: "Northwind HVAC", industry: "Facilities", crb7a_whmcsid: "182" },
    { accountid: id(2, "acc"), name: "Fabrikam Retail", industry: "Retail", crb7a_whmcsid: "204" },
    { accountid: id(3, "acc"), name: "Contoso Logistics", industry: "Logistics", crb7a_whmcsid: "217" },
    { accountid: id(4, "acc"), name: "Tailspin Hospitality", industry: "Hospitality", crb7a_whmcsid: null },
    { accountid: id(5, "acc"), name: "Adventure Works", industry: "Manufacturing", crb7a_whmcsid: null },
    { accountid: id(6, "acc"), name: "Wide World Importers", industry: "Logistics", crb7a_whmcsid: "238" },
    { accountid: id(7, "acc"), name: "Litware Inc.", industry: "Technology", crb7a_whmcsid: "241" },
];
// ---------- Resources / categories ----------
export const resourceCategories = [
    { bookableresourcecategoryid: id(1, "rc"), name: "Project Manager", hourlyRate: 220 },
    { bookableresourcecategoryid: id(2, "rc"), name: "Senior Engineer", hourlyRate: 180 },
    { bookableresourcecategoryid: id(3, "rc"), name: "Field Technician", hourlyRate: 140 },
    { bookableresourcecategoryid: id(4, "rc"), name: "Consultant", hourlyRate: 200 },
];
export const resources = [
    {
        bookableresourceid: id(1, "br"),
        name: "Tim Raines",
        userId: "tim-user-id",
        businessUnitId: "bu-root",
        resourceCategoryId: id(1, "rc"),
    },
    {
        bookableresourceid: id(2, "br"),
        name: "Jess Nguyen",
        userId: "jess-user-id",
        businessUnitId: "bu-field",
        resourceCategoryId: id(3, "rc"),
    },
    {
        bookableresourceid: id(3, "br"),
        name: "Alex Johnson",
        userId: "alex-user-id",
        businessUnitId: "bu-field",
        resourceCategoryId: id(2, "rc"),
    },
    {
        bookableresourceid: id(4, "br"),
        name: "Rob Davies",
        userId: "rob-user-id",
        businessUnitId: "bu-field",
        resourceCategoryId: id(3, "rc"),
    },
    {
        bookableresourceid: id(5, "br"),
        name: "Mike Patel",
        userId: "mike-user-id",
        businessUnitId: "bu-field",
        resourceCategoryId: id(4, "rc"),
    },
    {
        bookableresourceid: id(6, "br"),
        name: "Lin Park",
        userId: "lin-user-id",
        businessUnitId: "bu-root",
        resourceCategoryId: id(1, "rc"),
    },
    {
        bookableresourceid: id(7, "br"),
        name: "Sarah Chen",
        userId: "sarah-user-id",
        businessUnitId: "bu-root",
        resourceCategoryId: id(1, "rc"),
    },
];
// ---------- Service types (transaction categories) ----------
// msdyn_billingtype on each row drives the billable flag for time entries
// that reference it (see utils/billing.ts). "Site Survey" is complimentary —
// it doesn't bill the client but isn't internal time either.
//
// rate lives on the custom column crb7a_rate on msdyn_transactioncategory;
// rateUnit is derived from the OOB msdyn_defaultunit lookup (→ uom table)
// in the adapter. The OOB PO price-list tables aren't installed in this env
// — see DataverseAdapter.listTransactionCategories. Per-minute rates fit
// short-form work like emergency callouts where billing in whole hours
// overcharges; longer block work stays per-hour.
export const transactionCategories = [
    { msdyn_transactioncategoryid: id(1, "tc"), msdyn_description: "Consulting", msdyn_billingtype: "Chargeable", rate: 220, rateUnit: "Hour" },
    { msdyn_transactioncategoryid: id(2, "tc"), msdyn_description: "Installation", msdyn_billingtype: "Chargeable", rate: 180, rateUnit: "Hour" },
    { msdyn_transactioncategoryid: id(3, "tc"), msdyn_description: "Preventive Maintenance", msdyn_billingtype: "Chargeable", rate: 160, rateUnit: "Hour" },
    { msdyn_transactioncategoryid: id(4, "tc"), msdyn_description: "Emergency Callout", msdyn_billingtype: "Chargeable", rate: 3.5, rateUnit: "Minute" },
    { msdyn_transactioncategoryid: id(5, "tc"), msdyn_description: "Site Survey", msdyn_billingtype: "Complimentary" },
    { msdyn_transactioncategoryid: id(6, "tc"), msdyn_description: "Commissioning", msdyn_billingtype: "Chargeable", rate: 200, rateUnit: "Hour" },
];
// ---------- Work orders ----------
export const workOrders = [
    {
        msdyn_workorderid: id(1, "wo"),
        msdyn_name: "WO-1001 Rooftop Unit Service",
        msdyn_serviceaccount: id(1, "acc"),
        msdyn_systemstatus: "In Progress",
        scheduledDate: day(0),
    },
    {
        msdyn_workorderid: id(2, "wo"),
        msdyn_name: "WO-1002 Refrigeration Inspect",
        msdyn_serviceaccount: id(2, "acc"),
        msdyn_systemstatus: "Unscheduled",
        scheduledDate: day(0),
    },
    {
        msdyn_workorderid: id(3, "wo"),
        msdyn_name: "WO-1003 Fleet Maintenance",
        msdyn_serviceaccount: id(3, "acc"),
        msdyn_systemstatus: "Scheduled",
        scheduledDate: day(0),
    },
    {
        msdyn_workorderid: id(4, "wo"),
        msdyn_name: "WO-1004 Conveyor Repair",
        msdyn_serviceaccount: id(5, "acc"),
        msdyn_systemstatus: "In Progress",
        scheduledDate: day(0),
    },
    {
        msdyn_workorderid: id(5, "wo"),
        msdyn_name: "WO-1005 Kitchen Equipment",
        msdyn_serviceaccount: id(4, "acc"),
        msdyn_systemstatus: "Posted",
        scheduledDate: day(0),
    },
    {
        msdyn_workorderid: id(6, "wo"),
        msdyn_name: "WO-1006 Warehouse HVAC",
        msdyn_serviceaccount: id(6, "acc"),
        msdyn_systemstatus: "Completed",
        scheduledDate: day(0),
    },
    {
        msdyn_workorderid: id(7, "wo"),
        msdyn_name: "WO-1007 Server Room Cooling",
        msdyn_serviceaccount: id(7, "acc"),
        msdyn_systemstatus: "Canceled",
        scheduledDate: day(0),
    },
];
// ---------- Projects ----------
export const projects = [
    {
        msdyn_projectid: id(1, "prj"),
        msdyn_subject: "Northwind HQ Retrofit",
        msdyn_customer: id(1, "acc"),
        msdyn_projectmanager: "lin-user-id",
        ownerName: "Lin Park",
    },
    {
        msdyn_projectid: id(2, "prj"),
        msdyn_subject: "Fabrikam Store Rollout",
        msdyn_customer: id(2, "acc"),
        msdyn_projectmanager: "lin-user-id",
        ownerName: "Lin Park",
    },
    {
        msdyn_projectid: id(3, "prj"),
        msdyn_subject: "Contoso Depot Upgrade",
        msdyn_customer: id(3, "acc"),
        msdyn_projectmanager: "sarah-user-id",
        ownerName: "Sarah Chen",
    },
    {
        msdyn_projectid: id(4, "prj"),
        msdyn_subject: "Litware Data Center",
        msdyn_customer: id(7, "acc"),
        msdyn_projectmanager: "lin-user-id",
        ownerName: "Lin Park",
    },
];
export const projectTasks = [
    { msdyn_projecttaskid: id(1, "tk"), msdyn_subject: "Site Survey", msdyn_project: id(1, "prj") },
    { msdyn_projecttaskid: id(2, "tk"), msdyn_subject: "Installation", msdyn_project: id(1, "prj") },
    { msdyn_projecttaskid: id(3, "tk"), msdyn_subject: "Commissioning", msdyn_project: id(1, "prj") },
    { msdyn_projecttaskid: id(4, "tk"), msdyn_subject: "Design", msdyn_project: id(2, "prj") },
    { msdyn_projecttaskid: id(5, "tk"), msdyn_subject: "Rollout Wave 1", msdyn_project: id(2, "prj") },
    { msdyn_projecttaskid: id(6, "tk"), msdyn_subject: "Mobilization", msdyn_project: id(3, "prj") },
    { msdyn_projecttaskid: id(7, "tk"), msdyn_subject: "Cooling Spec", msdyn_project: id(4, "prj") },
];
// ---------- Bookings ----------
// FS schedule-board appointments under work orders. Raines doesn't currently
// use the schedule board, so this is intentionally sparse — just enough seed
// rows that the picker has something to show in environments that do.
export const bookings = [
    {
        bookableresourcebookingid: id(1, "bk"),
        name: "WO-1001 · Tim · Mon morning",
        workOrderId: id(1, "wo"),
        resourceId: id(1, "br"),
        starttime: day(0, 9),
        endtime: day(0, 12),
    },
    {
        bookableresourcebookingid: id(2, "bk"),
        name: "WO-1003 · Jess · Mon all-day",
        workOrderId: id(3, "wo"),
        resourceId: id(2, "br"),
        starttime: day(0, 8),
        endtime: day(0, 16),
    },
    {
        bookableresourcebookingid: id(3, "bk"),
        name: "WO-1004 · Rob · Tue all-day",
        workOrderId: id(4, "wo"),
        resourceId: id(4, "br"),
        starttime: day(1, 8),
        endtime: day(1, 17),
    },
];
// ---------- Time entries ----------
// Tim Raines = br-0001, current week starts Mon 18 May 2026.
// Dashboard shows: 8h this week, 1 submitted (Northwind retrofit), 2 approved, 0 returned.
export const timeEntries = [
    // --- Tim Raines this week ---
    {
        msdyn_timeentryid: id(1, "te"),
        msdyn_description: "Client workshop",
        msdyn_start: day(1, 9), // Tue 19
        msdyn_end: addHours(day(1, 9), 3),
        msdyn_duration: 180,
        msdyn_type: "Work",
        msdyn_entryStatus: "Draft",
        bookableresource: id(1, "br"),
        regardingobjectid: { type: "account", id: id(3, "acc"), display: "Contoso Logistics" },
        msdyn_transactioncategoryid: id(1, "tc"),
        resourceCategoryId: id(1, "rc"),
    },
    {
        msdyn_timeentryid: id(2, "te"),
        msdyn_description: "Survey kickoff",
        msdyn_start: day(0, 9), // Mon 18
        msdyn_end: addHours(day(0, 9), 5),
        msdyn_duration: 300,
        msdyn_type: "Work",
        msdyn_entryStatus: "Submitted",
        bookableresource: id(1, "br"),
        regardingobjectid: { type: "msdyn_project", id: id(1, "prj"), display: "Northwind HQ Retrofit" },
        msdyn_projecttaskid: id(2, "tk"),
        msdyn_transactioncategoryid: id(2, "tc"),
        resourceCategoryId: id(1, "rc"),
    },
    // Approved historical (drives dashboard "Approved: 2")
    {
        msdyn_timeentryid: id(3, "te"),
        msdyn_description: "Design review",
        msdyn_start: day(-5, 9),
        msdyn_end: addHours(day(-5, 9), 6),
        msdyn_duration: 360,
        msdyn_type: "Work",
        msdyn_entryStatus: "Approved",
        bookableresource: id(1, "br"),
        regardingobjectid: { type: "msdyn_project", id: id(2, "prj"), display: "Fabrikam Store Rollout" },
        msdyn_projecttaskid: id(4, "tk"),
        msdyn_transactioncategoryid: id(1, "tc"),
        resourceCategoryId: id(1, "rc"),
    },
    {
        msdyn_timeentryid: id(4, "te"),
        msdyn_description: "Strategy session",
        msdyn_start: day(-7, 9),
        msdyn_end: addHours(day(-7, 9), 4),
        msdyn_duration: 240,
        msdyn_type: "Work",
        msdyn_entryStatus: "Approved",
        bookableresource: id(1, "br"),
        regardingobjectid: { type: "account", id: id(1, "acc"), display: "Northwind HVAC" },
        msdyn_transactioncategoryid: id(1, "tc"),
        resourceCategoryId: id(1, "rc"),
    },
    // Tim's self-approve queue entry (matches Approvals screenshot)
    {
        msdyn_timeentryid: id(5, "te"),
        msdyn_description: "Installation work",
        msdyn_start: day(-1, 9), // Sun 17
        msdyn_end: addHours(day(-1, 9), 5),
        msdyn_duration: 300,
        msdyn_type: "Work",
        msdyn_entryStatus: "Submitted",
        bookableresource: id(1, "br"),
        regardingobjectid: { type: "msdyn_project", id: id(1, "prj"), display: "Northwind HQ Retrofit" },
        msdyn_projecttaskid: id(2, "tk"),
        msdyn_transactioncategoryid: id(2, "tc"),
        resourceCategoryId: id(1, "rc"),
    },
];
// Build out the entries seen in the Entries page (delegated queue ≈ 14 from other resources)
const otherResourceEntries = (() => {
    const rows = [
        { n: 100, date: 3, resource: "br-0002", woIdx: 3, tcIdx: 3, hours: 5 }, // 21 May Jess WO-1003 PM
        { n: 101, date: 2, resource: "br-0003", woIdx: 4, tcIdx: 2, hours: 7.5 }, // 20 May Alex WO-1004 Install
        { n: 102, date: 2, resource: "br-0002", woIdx: 3, tcIdx: 3, hours: 8 }, // 20 May Jess WO-1003 PM
        { n: 103, date: 1, resource: "br-0003", woIdx: 2, tcIdx: 4, hours: 7.5 }, // 19 May Alex WO-1002 Emerg
        { n: 104, date: 1, resource: "br-0002", woIdx: 3, tcIdx: 3, hours: 8 }, // 19 May Jess WO-1003 PM
        { n: 105, date: 1, resource: "br-0004", woIdx: 4, tcIdx: 2, hours: 9 }, // 19 May Rob WO-1004 Install
        { n: 106, date: 0, resource: "br-0003", woIdx: 4, tcIdx: 2, hours: 7.5 }, // 18 May Alex WO-1004 Install
        { n: 107, date: 0, resource: "br-0002", woIdx: 3, tcIdx: 3, hours: 8 }, // 18 May Jess WO-1003 PM
        { n: 108, date: 0, resource: "br-0005", woIdx: 1, tcIdx: 1, hours: 4 }, // 18 May Mike WO-1001 Consulting
        { n: 109, date: -1, resource: "br-0004", woIdx: 5, tcIdx: 6, hours: 6 },
        { n: 110, date: -1, resource: "br-0002", woIdx: 6, tcIdx: 3, hours: 8 },
        { n: 111, date: -2, resource: "br-0003", woIdx: 7, tcIdx: 2, hours: 7 },
        { n: 112, date: -2, resource: "br-0005", woIdx: 1, tcIdx: 4, hours: 5 },
        { n: 113, date: -3, resource: "br-0004", woIdx: 4, tcIdx: 2, hours: 8 },
    ];
    return rows.map((r) => {
        const wo = workOrders[r.woIdx - 1];
        const tc = transactionCategories[r.tcIdx - 1];
        return {
            msdyn_timeentryid: id(r.n, "te"),
            msdyn_description: `${tc.msdyn_description} — ${wo.msdyn_name}`,
            msdyn_start: day(r.date, 8),
            msdyn_end: addHours(day(r.date, 8), r.hours),
            msdyn_duration: Math.round(r.hours * 60),
            msdyn_type: "Work",
            msdyn_entryStatus: "Submitted",
            bookableresource: r.resource,
            regardingobjectid: {
                type: "msdyn_workorder",
                id: wo.msdyn_workorderid,
                display: wo.msdyn_name,
            },
            msdyn_transactioncategoryid: tc.msdyn_transactioncategoryid,
            resourceCategoryId: resources.find((b) => b.bookableresourceid === r.resource)
                ?.resourceCategoryId,
        };
    });
})();
timeEntries.push(...otherResourceEntries);
export const annotations = [];
